import * as React from "react";
import { Input, Modal, notification, Select } from "antd";
import { linksOf, request } from "../../../services/cpln";
import {
  ExpandVolumeReducerState,
  RunExpandVolumeReducerActionType,
  useRunExpandVolumeReducer,
} from "./reducer_expandVolume";
import { VolumeSet } from "../../../schema/types/volumeSet/entity";

interface Props {
  volumeSet: VolumeSet;
  initialLocation?: string;
  initialVolumeIndex?: string;
  initialStorageCapacity?: number;
  timeoutSeconds?: number;
  onClose: any;
  onDone: any;
  visible: boolean;
}

export const CommandModal_ExpandVolume: React.FC<Props> = ({
  volumeSet,
  initialLocation,
  initialVolumeIndex,
  initialStorageCapacity,
  timeoutSeconds,
  onClose,
  onDone,
  visible,
}) => {
  const selfLink = linksOf(volumeSet).self!;
  const [isLoading, setIsLoading] = React.useState(false);
  const [state, dispatch] = useRunExpandVolumeReducer(
    initialLocation,
    initialVolumeIndex,
    initialStorageCapacity !== undefined ? String(initialStorageCapacity) : undefined,
    timeoutSeconds !== undefined ? String(timeoutSeconds) : undefined,
  );
  async function handleConfirm() {
    try {
      setIsLoading(true);
      const spec: ExpandVolumeReducerState = JSON.parse(JSON.stringify(state));
      // TODO remove below after fixing number input
      spec.newStorageCapacity = Number(spec.newStorageCapacity) as any;
      spec.timeoutSeconds = Number(spec.timeoutSeconds) as any;
      await request({
        method: "post",
        url: `${selfLink}/-command`,
        body: {
          type: "expandVolume",
          spec: spec,
        },
      });
      onDone();
      notification.success({
        message: "Success",
        description: "Created Command.",
      });
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      notification.warning({
        message: "Failed",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  }
  let isValid = true;

  if (!state.location) isValid = false;
  if (!state.volumeIndex) isValid = false;
  if (!state.newStorageCapacity) isValid = false;

  return (
    <Modal
      width={450}
      open={visible}
      title="Expand Volume"
      okText={`Expand`}
      cancelButtonProps={{ disabled: isLoading }}
      okButtonProps={{ loading: isLoading, disabled: isLoading || !isValid, className: "action" }}
      onOk={handleConfirm}
      onCancel={onClose}
      maskClosable={false}
      destroyOnHidden
    >
      <div>Location</div>
      <Select
        className="mb-4 w-full"
        value={state.location}
        onChange={(value) => dispatch({ type: RunExpandVolumeReducerActionType.LOCATION, payload: value })}
        options={(volumeSet.status?.locations || []).map(({ name: l }) => ({
          label: l,
          value: l,
          disabled: false,
          isLabel: false,
        }))}
      />
      <div>Volume Index</div>
      <Input
        className="mb-4"
        name={"volumeIndex"}
        value={state.volumeIndex}
        onChange={(e) => dispatch({ type: RunExpandVolumeReducerActionType.INDEX, payload: e.target.value })}
      />
      <div>New Storage Capacity (GiB)</div>
      <Input
        className="mb-4"
        name={"storageCapacity"}
        value={state.newStorageCapacity}
        onChange={
          (e) => dispatch({ type: RunExpandVolumeReducerActionType.NEW_STORAGE_CAPACITY, payload: e.target.value }) // TODO send as number?
        }
      />
      <div>Timeout Seconds</div>
      <Input
        className="mb-4"
        name={"timeoutSeconds"}
        value={state.timeoutSeconds}
        onChange={
          (e) => dispatch({ type: RunExpandVolumeReducerActionType.TIMEout_SECONDS, payload: e.target.value }) // TODO send as number?
        }
      />
    </Modal>
  );
};
